export default "/static/media/icon-bell.143524db.svg";